import React from "react";

function FoundIcon() {
  return (
    <>
      <svg
        width="54"
        height="54"
        viewBox="0 0 54 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="27" cy="27" r="27" fill="#0A8900" fill-opacity="0.1" />
        <path
          d="M38.4286 21.8036L24.4286 35.8036C24.3067 35.926 24.1618 36.023 24.0022 36.0893C23.8427 36.1555 23.6716 36.1896 23.4989 36.1896C23.3262 36.1896 23.1551 36.1555 22.9956 36.0893C22.836 36.023 22.6912 35.926 22.5692 35.8036L16.4442 29.6786C16.3221 29.5565 16.2253 29.4116 16.1592 29.252C16.0931 29.0925 16.0591 28.9216 16.0591 28.7489C16.0591 28.5762 16.0931 28.4053 16.1592 28.2458C16.2253 28.0862 16.3221 27.9413 16.4442 27.8192C16.5663 27.6971 16.7112 27.6003 16.8708 27.5342C17.0303 27.4681 17.2012 27.4341 17.3739 27.4341C17.5466 27.4341 17.7175 27.4681 17.877 27.5342C18.0366 27.6003 18.1815 27.6971 18.3036 27.8192L23.5 33.0156L36.5714 19.9464C36.818 19.6998 37.1524 19.5613 37.5011 19.5613C37.8498 19.5613 38.1842 19.6998 38.4308 19.9464C38.6773 20.193 38.8159 20.5274 38.8159 20.8761C38.8159 21.2248 38.6773 21.5592 38.4308 21.8058L38.4286 21.8036Z"
          fill="#0A8900"
        />
      </svg>
    </>
  );
}

export default FoundIcon;
